export default {"src":"/_next/static/media/logo-migros-ferien.579a1721.svg","height":148,"width":486,"blurWidth":0,"blurHeight":0};